var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-container',[_c('el-container',{class:[_vm.$style.container]},[_c('div',{staticClass:"bg-body",class:[_vm.$style.main]},[_c('router-view')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }